<div class="chatbot-wrapper">
  <!-- Floating bubble -->
  <button class="chatbot-fab" (click)="toggle()" [attr.aria-label]="isOpen ? 'Close chat' : 'Chat with us'" [class.open]="isOpen">
    <svg *ngIf="!isOpen" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4.8 2.3A5 5 0 0 1 8 1h0a5 5 0 0 1 5 5v1h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1v3l-3-3H8a5 5 0 0 1-5-5V6a5 5 0 0 1 1.8-3.7z"/>
      <circle cx="17" cy="17" r="5"/>
      <path d="M17 15v4M15 17h4"/>
    </svg>
    <svg *ngIf="isOpen" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

  <!-- Chat panel -->
  <div class="chatbot-panel" *ngIf="isOpen" @panelAnim>
    <!-- Header -->
    <div class="chatbot-header">
      <div class="chatbot-header-info">
        <div class="chatbot-avatar">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4.8 2.3A5 5 0 0 1 8 1h0a5 5 0 0 1 5 5v1h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1v3l-3-3H8a5 5 0 0 1-5-5V6a5 5 0 0 1 1.8-3.7z"/>
          </svg>
        </div>
        <div>
          <div class="chatbot-title">Shree Radha Clinic</div>
          <div class="chatbot-status">
            <span class="status-dot" [class.online]="clinicStatus.open"></span>
            {{ clinicStatus.open ? 'Open Now' : 'Opens Mon–Sat, 6:30 PM' }}
          </div>
        </div>
      </div>
      <button class="chatbot-close" (click)="toggle()" aria-label="Close chat">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Messages -->
    <div class="chatbot-messages" #messagesContainer>
      <div *ngFor="let msg of messages" class="message" [class.bot]="msg.sender==='bot'" [class.user]="msg.sender==='user'" @messageAnim>
        <div class="message-avatar" *ngIf="msg.sender==='bot'">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4.8 2.3A5 5 0 0 1 8 1h0a5 5 0 0 1 5 5v1h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1v3l-3-3H8a5 5 0 0 1-5-5V6a5 5 0 0 1 1.8-3.7z"/>
          </svg>
        </div>
        <div class="message-bubble" [innerHTML]="msg.text | newlineToBr"></div>
        <button *ngIf="msg.action" class="action-btn" (click)="handleAction(msg.action)">
          {{ msg.action === 'open-whatsapp' ? '💬 Chat on WhatsApp' : '📍 Go to section' }}
        </button>
      </div>

      <!-- Typing indicator -->
      <div class="message bot typing-message" *ngIf="isTyping">
        <div class="message-avatar">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4.8 2.3A5 5 0 0 1 8 1h0a5 5 0 0 1 5 5v1h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1v3l-3-3H8a5 5 0 0 1-5-5V6a5 5 0 0 1 1.8-3.7z"/>
          </svg>
        </div>
        <div class="typing-indicator">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <!-- Quick replies -->
    <div class="chatbot-quick-replies" *ngIf="messages.length <= 1">
      <button *ngFor="let qr of quickReplies" class="quick-chip" (click)="handleQuickReply(qr)">
        {{ qr.quickLabel }}
      </button>
    </div>

    <!-- Input -->
    <div class="chatbot-input">
      <input type="text" [(ngModel)]="userInput" (keyup.enter)="send()" placeholder="Type your question..." aria-label="Type your question" autocomplete="off" />
      <button class="send-btn" (click)="send()" aria-label="Send message" [disabled]="!userInput.trim()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
        </svg>
      </button>
    </div>
  </div>
</div>
